// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__mElEu","header":"Tabs_header__o8+bY","tab":"Tabs_tab__kE2yZ","tabActive":"Tabs_tabActive__lux7w","content":"Tabs_content__BSFkP"};